import React, { useState } from 'react';
import {
  // Redirect,
  Route,
  Switch,
  useRouteMatch,
  withRouter,
} from 'react-router-dom';

import ClinicianInfo from './clinicians/clinicianInfo';
// import EditClinicianInfo from './clinicians/editClinicianInfo';
import EditEnrolmentInfo from './enrolments/editEnrolmentInfo';
// import EditPatientInfo from './patients/editPatientInfo';
import EditProgramInfo from './programs/editProgramInfo';
import FormInfo from './forms/formInfo';
import ListClinicians from './clinicians/listClinicians';
import ListClinicianSchedules from './clinicians/listClinicianSchedules';
import ListMySchedulesClinician from './clinicians/listMySchedulesClinician';
import ListPatients from './patients/listPatients';
import ListPatientSchedules from './patients/listPatientSchedules';
import ListPrograms from './programs/listPrograms';
import NoMatch from './noMatch';
import PatientInfo from './patients/patientInfo';

import { changeLang, getLang } from '../../languages/i18n';

function Clinician() {
  const { path } = useRouteMatch();

  const [language, setLanguage] = useState(getLang());

  const changeLanguage = (lang) => {
    setLanguage(lang);
    changeLang(lang);
  };

  return (
    <Switch>
      {/* Component que carregam per defecte, necessita tenir exact */}
      {/* ATENCIÓ: Listclinicians, més avall, també té associada la ruta ${path}/listClinicians */}
      {/*
      <Route exact path={path}>
        <ListClinicians />
      </Route>
      */}
      {/* +++++++++++++++++++++++++++++++++++++++++++++++ CLINICS +++++++++++++++++++++++++++++++++++++++++++++++ */}
      {/* De moment no empram aquesta ruta */}
      <Route path={`${path}/clinicianInfo/:idClinician`}>
        <ClinicianInfo lang={language} handleChangeLang={(lang) => changeLanguage(lang)} />
      </Route>
      {/* ATENCIÓ: Des de dins EditClinicianInfo crid ClinicianDetails que és qui carrega unes dades o altres depenent de type */}
      {/* sembla que per al DOM, independement de type, estic cridant al mateix component i a la segona vegada no fa render de ClinicianDetails, */}
      {/* pel que mostra el que ja tenia. Per indicar que estic cridant a 2 components EditClinicianInfo diferents els he de diferencia amb key */}
      {/* De moment no empram aquesta ruta */}
      {/* <Route path={`${path}/editClinicianInfo/:idClinician`}>
        <EditClinicianInfo type='edit' key='editClinicianInfo' />
      </Route> */}
      <Route path={`${path}/listClinicians`}>
        <ListClinicians lang={language} handleChangeLang={(lang) => changeLanguage(lang)} />
      </Route>
      {/* ATENCIÓ: nova ruta - afegida neus */}
      <Route path={`${path}/clinicianSchedulesInfo/:idClinician`}>
        <ListClinicianSchedules lang={language} handleChangeLang={(lang) => changeLanguage(lang)} />
      </Route>
      <Route path={`${path}/mySchedulesInfoClinician/:idClinician`}>
        <ListMySchedulesClinician lang={language} handleChangeLang={(lang) => changeLanguage(lang)} />
      </Route>
      {/* ATENCIÓ: Posar key a la cridada EditClinicianInfo */}
      {/* De moment no empram aquesta ruta */}
      {/* <Route path={`${path}/newClinicianInfo`}>
        <EditClinicianInfo type='new' key='newClinicianInfo' />
      </Route> */}
      {/* +++++++++++++++++++++++++++++++++++++++++++++++ ENROLMENTS +++++++++++++++++++++++++++++++++++++++++++++++ */}
      <Route path={`${path}/editEnrolmentInfo/:idEnrolment`}>
        <EditEnrolmentInfo lang={language} handleChangeLang={(lang) => changeLanguage(lang)} />
      </Route>
      {/* +++++++++++++++++++++++++++++++++++++++++++++++ FORMULARIS +++++++++++++++++++++++++++++++++++++++++++++++ */}
      <Route path={`${path}/formInfo/:programId/:userScheduleId`}>
        <FormInfo lang={language} handleChangeLang={(lang) => changeLanguage(lang)} />
      </Route>
      {/* +++++++++++++++++++++++++++++++++++++++++++++++ PACIENTS +++++++++++++++++++++++++++++++++++++++++++++++ */}
      {/* ATENCIÓ: Posar key a la cridada EditClinicianInfo */}
      {/* De moment no empram aquesta ruta */}
      {/* <Route path={`${path}/editPatientInfo/:idPatient`}>
        <EditPatientInfo type='edit' key='editPatientInfo' />
      </Route> */}
      <Route path={`${path}/listPatients`}>
        <ListPatients lang={language} handleChangeLang={(lang) => changeLanguage(lang)} />
      </Route>
      {/* ATENCIÓ: Posar key a la cridada EditClinicianInfo */}
      {/* De moment no empram aquesta ruta */}
      {/* <Route path={`${path}/newPatientInfo`}>
        <EditPatientInfo type='new' key='newPatientInfo' />
      </Route> */}
      <Route path={`${path}/patientInfo/:idPatient`}>
        <PatientInfo lang={language} handleChangeLang={(lang) => changeLanguage(lang)} />
      </Route>
      {/* ATENCIÓ: nova ruta - afegida neus */}
      <Route path={`${path}/patientSchedulesInfo/:idPatient`}>
        <ListPatientSchedules lang={language} handleChangeLang={(lang) => changeLanguage(lang)} />
      </Route>
      {/* +++++++++++++++++++++++++++++++++++++++++++++++ PROGRAMES +++++++++++++++++++++++++++++++++++++++++++++++ */}
      {/* ATENCIÓ: Posar key a la cridada EditProgramInfo */}
      <Route path={`${path}/editProgramInfo/:idProgram`}>
        <EditProgramInfo type='edit' key='editProgramInfo' lang={language} handleChangeLang={(lang) => changeLanguage(lang)} />
      </Route>
      <Route path={`${path}/listPrograms`}>
        <ListPrograms lang={language} handleChangeLang={(lang) => changeLanguage(lang)} />
      </Route>
      {/* ATENCIÓ: Posar key a la cridada EditProgramInfo */}
      {/* De moment no empram aquesta ruta */}
      {/* <Route path={`${path}/newProgramInfo`}>
        <EditProgramInfo type='new' key='newProgramInfo' />
      </Route> */}
      {/* NO MATCH */}
      <Route path='*'>
        <NoMatch />
        {/* <Redirect to='/' /> // Alternativa a NoMatch, en lloc de mostrar NoMatch va directa a la pantalla d'inici */}
      </Route>
    </Switch>
  );
}

export default withRouter(Clinician);
